// Footer accordion
$(".footer-block--menu .footer-block__heading").on("click", (e) => {
  const $curr = $(e.currentTarget);
  const isActived = $curr.hasClass("active");
  const $contentWrapper = $curr.parent().find(".footer-block__details-content-wrapper");
  const $content = $curr.parent().find(".footer-block__details-content");
  if (isActived) {
    $contentWrapper.css("height", 0);
    $curr.removeClass("active");
  } else {
    $contentWrapper.css("height", $content[0].clientHeight);
    $curr.addClass("active");
  }
});

// Update footer menu height
window.addEventListener("resize", () => {
  if (window.innerWidth >= 750) return;
  $(".footer-block--menu .footer-block__heading").each((i, el) => {
    const $el = $(el);
    const $contentWrapper = $el.parent().find(".footer-block__details-content-wrapper");
    const $content = $el.parent().find(".footer-block__details-content");
    if ($el.hasClass("active")) {
      $contentWrapper.css("height", $content[0].clientHeight);
    }
  });
});


// window.addEventListener("DOMContentLoaded", function () {
  if($('.zuidijiageRight>span').text()){
    $('.evaluateimgp1').text($('.zuidijiageRight>span').text())
  }
function getCliidFun(){
  function setCookieWithExpiration(name, value, daysUntilExpire) {
      var date = new Date();
      date.setTime(date.getTime() + (daysUntilExpire * 24 * 60 * 60 * 1000));
      var expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }
  var params = new URLSearchParams(window.location.search);
  var param1 = params.get('gclid')
  if(param1){
    setCookieWithExpiration("clid", param1, 30);
    var today = new Date();
    var DD = String(today.getDate()).padStart(2, '0')
    var MM = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    hh =  String(today.getHours()).padStart(2, '0')
    mm = String(today.getMinutes()).padStart(2, '0')
    ss = String(today.getSeconds()).padStart(2, '0')
    today = yyyy + '-' + MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss;
    setCookieWithExpiration("clidCreateTime", today, 30);
  }
}
if(getCookies().clid=='null'||!getCookies().clid){
  getCliidFun()
}else{
  var params = new URLSearchParams(window.location.search);
  var param1 = params.get('gclid')
  if(param1==getCookies().clid){
    
  }else{
    getCliidFun()
  }
}
var documentreferrer=document.referrer
if(documentreferrer){
  if(documentreferrer.indexOf('www.racetopprint.com')<0){
    var obj=[{
      operationType:'form_url',
      fromUrl:document.referrer,
      clidCreateTime:getCookies().clidCreateTime,
      clid:getCookies().clid,
      currentUrl:window.location.href
     }]
    $.ajax({
      url: newlocaURLaddPurchaseRecord,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(obj),
      success: function(response) {
           
      }
    })
    localStorage.setItem('documentreferrer', documentreferrer);
  }
}else{
  
}
  // activity
$('.zuidijiageRight').click(function() {
	$('body,html').animate({
		scrollTop: $('.evaluatediv ').offset().top - 260
	}, 500)
})
$('.Productclassification1racetopprintMobole').click(function() {
	$('body,html').animate({
		scrollTop: $('.evaluatediv ').offset().top - 260
	}, 500)
})
$('.daohangheight').css('height', 'calc(var(--announcement-bar-height) + var(--header-height))');
$('#HeaderMenu-MenuList-1').css('top', $('.headerz').height());
$(window).resize(function() {
  $('.daohangheight').css('height', 'calc(var(--announcement-bar-height) + var(--header-height))');
  $('#HeaderMenu-MenuList-1').css('top', $('.headerz').height());
});
var swiper = new Swiper(".multicolumn-right-swiper1", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      }
    });
  // activityend
//customer-revies
  var leftBigImgSwiper = new Swiper('.absloute-swiper-content .left-big-img-swiper', {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        thumbs: {
            swiper: thumbsRightSwiper,
        },
        allowTouchMove: false
    });
    var thumbsRightSwiper = new Swiper('.relative-swiper-content .thumbs-right-swiper', {
        slidesPerView: 4,
        spaceBetween: 10,
        loop: true,
        watchSlidesVisibility: true,
        navigation: {
            nextEl: ".relative-swiper-content .swiper-tab-content .swiper-button-next",
            prevEl: ".relative-swiper-content .swiper-tab-content .swiper-button-prev",
        },
        pagination: {
            el: '.relative-swiper-content .swiper-tab-content .swiper-pagination',
            clickable: true
        },
        breakpoints: {
            280: {
                slidesPerView: 1.3,
                slidesPerGroup: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            1080: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 20,
            }
        },
        on: {
            slideChangeTransitionStart: function () {
                var _index = this.realIndex;
                leftBigImgSwiper.slideToLoop(_index, 500, false);
            },
        },
    });
    $('.relative-swiper-content .item-detail').on('click', function () {
        var _this = $(this);
        if (!_this.hasClass('show')) {
            _this.addClass('show');
            _this.css('-webkit-line-clamp', 'unset');
        } else {
            _this.removeClass('show');
            _this.css('-webkit-line-clamp', '4');
        }
    });
  //endcustomer-revies
  //footer

  window.onscroll = function() {
    scrollFunction()
  };
  function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("btnTop").style.display = "block";
    } else {
      document.getElementById("btnTop").style.display = "none";
    }
  }
 function returnTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
 }
//footerend
  // header
  var arr=$('.Breadcrumb li a')
    var arrr=$('.list-menu--inline>li>header-menu>a')
    arr.map(res=>{
      arrr.map(re=>{
        if($(arr[res]).text()==$(arrr[re]).text()){
          $(arr[res]).attr('href',$(arrr[re]).attr('href'))
        }
      })
    })
    $('.searchMobile').click(function(){
      if($('.search-modal__formMobile').css('opacity')==1){
        $('.search-modal__formMobile').css('opacity',0)
        $('.header__search').css('display','none')
      }else{
        $('.search-modal__formMobile').css('opacity',1)
        $('.header__search').css('display','block')
      }
    })
  // headerend
//video
$('.aasdas').click(function(){
      $('.aasdas').html("<video style='width:100%;height:100%;' controls muted><source src='https://cdn.shopify.com/videos/c/o/v/6dbdc3be79264c719be148aec157f7ad.mp4'>Your browser does not support the video tag.</video>");
  $('.aasdas video')[0].play()
    })

// });
if(document.body.clientWidth>750){
var swiper = new Swiper(".mySwiperMobile", {
      pagination: {
        el: ".swiper-pagination",
        clickable :true,
      },
     navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });
    $('.mySwiperMobile .swiper-slide').height($('.swiper-wrapper').height())
}
if($('.product__titleh1').text()){
function formatDate(date) {
  // var deliveryDaysConfiguration=$('.deliveryDaysConfiguration').text()
    var product__titleh1Title=$('.product__titleh1').text()
    // let value = product__titleh1Title?(product__titleh1Title.indexOf('Stickers')>=0||product__titleh1Title.indexOf('Labels')>=0||$('.newproductid').text()==8740338270460||$('.newproductid').text()==8740357243132||$('.newproductid').text()==8734549836028||$('.newproductid').text()==8784062611708||$('.newproductid').text()==8648184987900)?6:7:6
    let value=7
    if($('.newproductid').text()){
      if(productDeliveryFreight[$('.newproductid').text()]&&+productDeliveryFreight[$('.newproductid').text()]>value){
        value=+productDeliveryFreight[$('.newproductid').text()]
      }
    }
    if($('.newproductid').text()){
      if(productDeliveryFreight[$('.newproductid').text()]&&+productDeliveryFreight[$('.newproductid').text()]>value){
        value=+productDeliveryFreight[$('.newproductid').text()]
      }
    }
    // if(product__titleh1Title.indexOf('Stickers')>=0||product__titleh1Title.indexOf('Labels')>=0||$('.newproductid').text()==8714706583804||$('.newproductid').text()==8740338270460||$('.newproductid').text()==8740357243132||$('.newproductid').text()==8734549836028||$('.newproductid').text()==8784062611708||$('.newproductid').text()==8648184987900||$('.newproductid').text()==8911405646076){
    //   value=6
    // }
    // if(deliveryDaysConfiguration){
    //   if(value){
    //     if(value>deliveryDaysConfiguration){
    //       localStorage.setItem('deliveryDaysConfiguration',value)
    //     }
    //   }else{
    //     localStorage.setItem('deliveryDaysConfiguration',deliveryDaysConfiguration)
    //   }
    // }
    function addBusinessDays(daysToAdd) {
      const currentDate = new Date();
      let addedDays = 0;
    
      while (addedDays < daysToAdd) {
        currentDate.setDate(currentDate.getDate() + 1); // 加 1 天
        const dayOfWeek = currentDate.getDay(); // 0（周日） ~ 6（周六）
    
        // 如果是工作日（周一~周五），才计入
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          addedDays++;
        }
      }
    
      return currentDate;
    }
    
    var data=addBusinessDays(value)
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const monthIndex = data.getMonth();
    const dayIndex = data.getDay();
    const day = data.getDate();
    return `${days[dayIndex]}, ${months[monthIndex]} ${day}`;
}
  var currentDate = new Date();
  const formattedDate = formatDate(currentDate);
  $('.timegMobileh3').text(formattedDate)
  $('.Comparablequality span').text(formattedDate)
}
function formatDatez(date){
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  date.setDate(date.getDate() + (6));
  const monthIndex = date.getMonth();
  const dayIndex = date.getDay();
  const day = date.getDate();
  return `${days[dayIndex]}, ${months[monthIndex]} ${day}`;
}
$('.timegMobileh3z').text(formatDatez(new Date()))
if(document.body.clientWidth<750){
  $('.indexvideoMobile').click(function(){
      $('.indexvideoMobile').html("<video style='width:100%;height:100%;' controls muted><source src='https://cdn.shopify.com/videos/c/o/v/6dbdc3be79264c719be148aec157f7ad.mp4' type='video/mp4'>Your browser does not support the video tag.</video>");
    $('.indexvideoMobile video')[0].play()
  })
  var swiper = new Swiper(".newmySwiperMobile", {
     // navigation: {
     //    nextEl: ".swiper-button-next",
     //    prevEl: ".swiper-button-prev",
     //  },
     //  autoplay: {
     //    delay: 5000,
     //    disableOnInteraction: false,
     //  },
      loop: false
    });
   $('.newmySwiperMobile .swiper-slide:last-child').height($('.newmySwiperMobile').height())
}
$('.searchMobile').click(function(){
  if($('.header__headingLogoMobole').css('z-index')==3){
    $('.header__headingLogoMobole').css('z-index',0)
  }else{
    $('.header__headingLogoMobole').css('z-index',3)
  }
})
$('.cart-notification__close').click(function(){
    $('#cart-notification').removeClass('active')
  })
$('.FAQsz p').click(function() {
	$(this).next().toggle();
  var text = $(this).find('span').text().trim();
  $(this).find('span').text(text == '+' ? '-' : '+');
})
$('.moreTitle').click(function(){
  if($(this).prev().css('-webkit-line-clamp')=='none'){
  $(this).prev().css('-webkit-line-clamp','2')
    $(this).text('more')
  }else{
    $(this).prev().css('-webkit-line-clamp','initial')
    $(this).text('fold')
  }
})
var tupianheaderwenzi=$($('.tupianheaderwenzi')[0]).text()
sessionStorage.setItem('tupianheaderwenzi', tupianheaderwenzi)
var swiper = new Swiper(".swiperzhekouwenzi", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      }
    });
$('.addnew-right').click(function() {
      var textToCopy = $(this).attr('val')
      var textarea = $('<textarea></textarea>');
      textarea.text(textToCopy);
      $('body').append(textarea);
      textarea.select();
      try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'Copy successful' : 'Copy failed, please manually copy';
          $('.tipz').text(msg)
      	  $('.tipz').css('display','block')
          setTimeout(res => {
    		$('.tipz').css('display','none')
          }, 2000)
      } catch (err) {
      }
      textarea.remove();
})
$('.HalloweenBannerDiv1 i').click(function() {
      var textToCopy = $(this).attr('val')
      var textarea = $('<textarea></textarea>');
      textarea.text(textToCopy);
      $('body').append(textarea);
      textarea.select();
      try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'Copy successful' : 'Copy failed, please manually copy';
          $('.tipz').text(msg)
      	  $('.tipz').css('display','block')
          setTimeout(res => {
    		$('.tipz').css('display','none')
          }, 2000)
      } catch (err) {
      }
      textarea.remove();
})
$('.addcode i').click(function() {
      var textToCopy = $(this).attr('val')
      var textarea = $('<textarea></textarea>');
      textarea.text(textToCopy);
      $('body').append(textarea);
      textarea.select();
      try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'Copy successful' : 'Copy failed, please manually copy';
          $('.tipz').text(msg)
      	  $('.tipz').css('display','block')
          setTimeout(res => {
    		$('.tipz').css('display','none')
          }, 2000)
      } catch (err) {
      }
      textarea.remove();
})
// $('.ThanksgivingProductTop span:nth-child(2)').click(function() {
//       var textToCopy = $(this).attr('val')
//       var textarea = $('<textarea></textarea>');
//       textarea.text(textToCopy);
//       $('body').append(textarea);
//       textarea.select();
//       try {
//           var successful = document.execCommand('copy');
//           var msg = successful ? 'Copy successful' : 'Copy failed, please manually copy';
//           $('.tipz').text(msg)
//       	  $('.tipz').css('display','block')
//           setTimeout(res => {
//     		$('.tipz').css('display','none')
//           }, 2000)
//       } catch (err) {
//       }
//       textarea.remove();
// })
// $('.thanks-Text-Ends-Copy').click(function() {
//       var textToCopy = $(this).attr('val')
//       var textarea = $('<textarea></textarea>');
//       textarea.text(textToCopy);
//       $('body').append(textarea);
//       textarea.select();
//       try {
//           var successful = document.execCommand('copy');
//           var msg = successful ? 'Copy successful' : 'Copy failed, please manually copy';
//           $('.tipz').text(msg)
//       	  $('.tipz').css('display','block')
//           setTimeout(res => {
//     		$('.tipz').css('display','none')
//           }, 2000)
//       } catch (err) {
//       }
//       textarea.remove();
// })
$('.tipJustHoliday').click(function() {
      var textToCopy = $(this).attr('val')
      var textarea = $('<textarea></textarea>');
      textarea.text(textToCopy);
      $('body').append(textarea);
      textarea.select();
      try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'Copy successful' : 'Copy failed, please manually copy';
          $('.tipz').text(msg)
      	  $('.tipz').css('display','block')
          setTimeout(res => {
    		$('.tipz').css('display','none')
          }, 2000)
      } catch (err) {
      }
      textarea.remove();
})
$('.menu-drawer__account').click(function(e){
  e.preventDefault()
  if($(this).attr('href')=='/account/login'&&window.location.href.indexOf('account/login')<0&&window.location.href.indexOf('account/register')){
    localStorage.setItem('navigaUrl', window.location.href);
  }
  window.location.href=$(this).attr('href')
})
$('.header__icon--account').click(function(e){
  e.preventDefault()
  if($(this).attr('href')=='/account/login'&&window.location.href.indexOf('account/login')<0&&window.location.href.indexOf('account/register')){
    localStorage.setItem('navigaUrl', window.location.href);
  }
  window.location.href=$(this).attr('href')
})
$('.CustomStickersProduct span').click(function(){
  $('.CustomStickersProduct .active').removeClass('active')
  $(this).addClass('active')
  $('.Customlist>div').css('display','none')
  var str=$(this).text()
  if(str=='All'){
    $('.Customlist >div').css('display','block')
  }else{
    var Customlist=$('.Customlist >div')
    Customlist.map(res=>{
      if($(Customlist[res]).attr('stickerssmalltype')){
        if($(Customlist[res]).attr('stickerssmalltype').indexOf(str)>=0||$(Customlist[res]).attr('stickerssmalltype').indexOf('lids')>=0){
          $(Customlist[res]).css('display','block')
        }
      }
    })
    if(!$('.Customlist>div:first-child').attr('stickerssmalltype')){
      $('.Customlist>div:first-child').css('display','block')
    }
  }
  var height=$('#shopify-section-header ').height()
  if(window.innerWidth<750){
    height=height+60
  }else{
    height=height+20
  }
  $('body,html').animate({
		scrollTop: height
	}, 500)
})
// $(window).scroll(function() {
//     if ($(window).scrollTop() > ($('.ThanksBanner').height()?$('.ThanksBanner').height():$('.HalloweenBanner').height()?$('.HalloweenBanner').height():$('.section-header').height())) {
//       $('.CustomStickersProduct').css('position','fixed')
//       $('.CustomStickersProduct').css('width','100%')
//       $('.CustomStickersProduct').css('background','#fff')
//       $('.CustomStickersProduct').css('left','0')
//       $('.CustomStickersProduct').css('top',$('.section-header').height())
//       $('.CustomStickersProduct').css('z-index','9')
//     }else{
//       $('.CustomStickersProduct').css('position','initial')
//     }
// });
if(localStorage.getItem('navigaUrl')){
  if(localStorage.getItem('navigaUrl').indexOf('transfer-sticker-deals')>=0){
    $('.loginDeal').css('display','block')
    $('.loginDealbutton').css('margin-top','10px')
  }
}
var swiper = new Swiper(".Thanksgiving", {
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    loop: false
});